import { z } from 'zod';

import type { ProviderInput } from '@/lib/api/domains/providers';

/*
 * Provider form schema. Mirrors the invoice/client form pattern: a Zod schema
 * for the fields the user edits, plus a `toProviderInput` transform to the API
 * input shape. Optional text fields normalize empty strings to `undefined` so
 * we never send a blank DBA/type to the BFF.
 */
export const providerFormSchema = z.object({
  name: z.string().min(1, 'Name is required.'),
  dbaName: z.string().optional(),
  providerType: z.string().optional(),
  status: z.enum(['active', 'inactive']),
});

export type ProviderFormValues = z.infer<typeof providerFormSchema>;

/** Convert form values to the API input shape (drops blank optionals). */
export function toProviderInput(values: ProviderFormValues): ProviderInput {
  return {
    name: values.name,
    status: values.status,
    ...(values.dbaName?.trim() ? { dbaName: values.dbaName.trim() } : {}),
    ...(values.providerType?.trim()
      ? { providerType: values.providerType.trim() }
      : {}),
  };
}
